// extracted by mini-css-extract-plugin
module.exports = {"subscriptionVoucherWarnModal":"J","header":"K","body":"L","buttonRow":"M","buttonWrapper":"N","button":"O","error":"P"};